import { v4 as uuid } from 'uuid';

import type { ListItem } from './types';

export const findImage = (images: ListItem['images'], orientation: 'landscape' | 'portrait', size: 'small' | 'medium' | 'large', kind = 'cover') => {
  const getImageScore = (image: ListItem['images'][number]) => {
    let score = 0;
    if (image.orientation === orientation) score += 4;
    if (kind && image.kind === kind) score += 3;

    if (size === image.size) score += 5;
    if (size === 'medium' && image.size === 'large') score += 2;
    if (size === 'medium' && image.size === 'small') score += 1;

    if (size === 'small' && image.size === 'medium') score += 2;
    if (size === 'small' && image.size === 'large') score += 1;

    if (size === 'large' && image.size === 'medium') score += 2;
    if (size === 'large' && image.size === 'small') score += 1;

    return score;
  };

  const best = images.reduce((previousValue, currentValue) => {
    return getImageScore(currentValue) > getImageScore(previousValue) ? currentValue : previousValue;
  }, images[0]);

  return best?.url || '';
};

export const fingerprint = uuid();

export const fetchWithFingerprint = (input: string | URL | Request, init?: RequestInit) => {
  return fetch(input, {
    ...init,
    headers: {
      ...(init?.headers || {}),
      'X-Stream-Iq-Fingerprint': fingerprint,
    },
  });
};
